module.exports = __webpack_public_path__ + "img/images-search.96a01e18.svg";